import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PageSubscribeComponent} from './page-subscribe.component';
import {PaymentWizardWideComponent} from './payment-wizard-wide/payment-wizard-wide.component';

const routes: Routes = [
  {
    path: '',
    component: PageSubscribeComponent
  },
  {
    path: 'payment',
    component: PaymentWizardWideComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PageSubscribeRoutingModule {}
